class SpoOrderQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.order_items = []
		this.supplier_invoices = null

		this.supplier_po_amount = 0
		this.supplier_po_date = null
		this.supplier_po_document = null
		this.supplier_po_number = null
		this.supplier_po_status = 'ACTIVE'
		this.payment_terms_list = null
		this.billing_address = null
		this.payment_terms_list = []
		this.minimum_order_quantity = null
		this.quote_type = 'FOR'
		this.message = null
		// this.input_type = null
		this.terms_and_conditions = `We declare that this invoice shows the actual price of the goods and all the particulars are true and correct.\n1. Interest upto 24% p.a. will be charged after a grace period of 7 days if the payment is not received as per the payment terms.\n2. Risk is transferred on delivery of goods to the party.\n3. All disputes are subject to Delhi Jurisdiction only.\n4. Weight Tolerance :- +/- 0.5% OF Invoiced Weight Visit www.metalbook.app / Download Metalbook app (Download App) to track your current order, see past invoices and orders with Metalbook, ledger and other details. COMPANY'S BANK DETAILS BANK NAME : Standard Chartered Bank A/C NO : 53105141407 IFSC CODE : SCBL0036025`

		// '1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n'
		this.original_supplier_po_number = null
		// added keys
		this.terms = null
		this.supplier_po_documents = []
	}
}

export default SpoOrderQuote
